import {
    request,
    setSessionStorage,
    getSessionStorage,
} from '@vfde-fe/sails_core';
import {
    call,
    put,
    select,
    takeLatest,
} from 'redux-saga/effects';
import {
    GET_ADDRESS,
    GLASFASER_API_URL,
    INIT_ADDRESS_FORM,
    INIT_APP,
} from './constant';
import { selectFormData } from './selector';
import {
    getAddressSuccess,
    getAddressNotFound,
    handleInvalidApiCall,
    handleValidApiCall,
    trackAddressFound,
    trackAddressNotFound,
    trackInitialPageView,
} from './action';
import {
    SESSION_STORAGE_GLASFASER_VFP_FLOW,
} from '../../constant';
import { getDecodedResponseData, getQueryString } from './helpers/sagaHelper';

/**
 * getApiData
 */
export function* getGlasfaserApiData () {
    const formData = yield select(selectFormData());
    const queryString = getQueryString(formData);

    try {
        const apiURL = GLASFASER_API_URL + queryString;
        const response = yield call(request, apiURL);
        const responseData = response.body.data;

        yield put(handleValidApiCall(responseData));

        if (!responseData) {
            yield call(resetSessionStorage);
            yield put(getAddressNotFound());
            yield put(trackAddressNotFound());
        } else {
            const decodedResponseData = getDecodedResponseData(responseData);

            yield call(setSessionStorageResult, decodedResponseData);
            yield put(getAddressSuccess());
            yield put(trackAddressFound(responseData.ADRESSART, responseData.TECHNOLOGIE));
        }

    } catch (e) {
        yield put(handleInvalidApiCall());
    }
}

/**
 * initTracking
 */
export function* initTracking () {
    yield put(trackInitialPageView());
}

/**
 * saves result of last adress check in session storage
 */
export function* setSessionStorageResult (responseData) {
    yield call(setSessionStorage, SESSION_STORAGE_GLASFASER_VFP_FLOW, responseData);
}

/**
 * saves result of last adress check in session storage
 */
export function* getSessionStorageResult () {
    const sessionStorageState = yield getSessionStorage(SESSION_STORAGE_GLASFASER_VFP_FLOW);
    const keyLen = Object.keys(sessionStorageState).length;

    if (0 < keyLen) {
        yield put(handleValidApiCall(sessionStorageState));
        yield put(getAddressSuccess());
    }
}

/**
 * saves result of last adress check in session storage
 */
export function* resetSessionStorage () {
    sessionStorage.removeItem(SESSION_STORAGE_GLASFASER_VFP_FLOW);
}

/**
 * export form data saga
 */
export default function* glasfaserVfpSaga () {
    yield takeLatest(GET_ADDRESS, getGlasfaserApiData);
    yield takeLatest(INIT_APP, getSessionStorageResult);
    yield takeLatest(INIT_ADDRESS_FORM, initTracking);
}
